// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d304c2e9","627":"ec278bac","903":"562b5439","973":"f1ccf2bb"}[chunkId] + ".chunk.js";
};